import React from 'react';
import './travel-app.scss';

const APPLE_STORE_URL = "https://apps.apple.com/sg/app/teleport-now/id6756201717";
const ANDROID_STORE_URL = "https://play.google.com/store/apps/details?id=sg.teleportnow.app";

const trackStoreClick = (store) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("event", "app_store_click", {
      store,
      placement: "homepage_final_cta",
    });
  }
};

export default function TravelApp() {
  return (
    <section className="travel-app">
      <div className="content-box">
        <p className="eyebrow">Ready for takeoff</p>
        <h2 className="title">Download once. Travel lighter every time.</h2>
        <p className="subtitle">
          Keep trip essentials, rewards, eSIM data, deals, and support inside
          one app built for modern travelers.
        </p>

        <div className="store-links">
          <a
            href={APPLE_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="store-btn"
            onClick={() => trackStoreClick("app_store")}
          >
            <img src="/images/icons/appstore.svg" alt="Download on App Store" />
          </a>

          <a
            href={ANDROID_STORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="store-btn"
            onClick={() => trackStoreClick("google_play")}
          >
            <img src="/images/icons/googleplay.svg" alt="Get it on Google Play" />
          </a>
        </div>
      </div>
    </section>
  );
}
